// PAYROLL SYSTEM PAGE
export const payrollSystemContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Business Tools
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'Payroll System', size: 'h1' },
        {
          type: 'text',
          content: 'Streamlined payroll management for businesses',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'A comprehensive payroll management system that handles employee salaries, tax calculations, and payment processing.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <span style={{
              background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '600'
            }}>
              Completed
            </span>
          )
        }
      ]
    },

    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '👥', title: 'Employee Management', desc: 'Manage employee profiles and details' },
                { icon: '💰', title: 'Salary Processing', desc: 'Automated salary calculations and disbursements' },
                { icon: '📊', title: 'Tax Calculations', desc: 'Automatic tax deductions and reporting' },
                { icon: '📄', title: 'Pay Slips', desc: 'Generate detailed pay slips for employees' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    {
      id: 'tech',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {['React', 'Node.js', 'Database', 'Authentication'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>{tech}</span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'Payroll System',
    text: 'Simplify your payroll operations',
    button: { text: 'See more work →', url: '/' }
  }
};
